import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './index.css'
import { loadRuntimeConfig } from './lib/env'

const container = document.getElementById('root')

if (container === null) {
  throw new Error('Root element #root is missing from index.html')
}

// The issuer, client id and API base come from GET /config.json when the app serves this bundle
// (dev, ini); the baked VITE_* values stay in force when it does not (Vite dev server, qa/prod's
// S3 origin). loadRuntimeConfig never throws, so the app always renders -- but only after the
// answer is in, so no component reads the baked issuer and later a different one.
const root = createRoot(container)

void loadRuntimeConfig().then(() => {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
